<template>
    <div class="container">
        <form class="form-horizontal col-md-6 offset-md-3 col-lg-8 offset-lg-2" role="form" @submit.prevent="login">
            <div class="row">
                <div class="col-md-6 offset-md-3 col-lg-4 offset-lg-4 text-center">
                    <h2>Baseline<br>เข้าสู่ระบบ</h2>
                    <hr>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 offset-md-3">
                    <div class="form-group has-danger">
                        <label class="sr-only" for="email">อีเมล</label>
                        <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                            <input type="text" name="email" class="form-control" id="email"
                                   v-model="form.email"
                                   placeholder="you@example.com" required autofocus>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 offset-md-3">
                    <div class="form-group">
                        <label class="sr-only" for="password">รหัสผ่าน</label>
                        <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                            <input type="password" name="password" class="form-control" id="password"
                                   v-model="form.password"
                                   placeholder="Password" required>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="padding-top: 1rem">
                <div class="col-md-6 offset-md-3 text-center">
                    <button type="submit" class="btn btn-success btn-block" v-if="loading===false">
                        <icon name="sign-in-alt"></icon>
                        เข้าสู่ระบบ
                    </button>
                    <b-button variant="success" block disabled v-else>
                        <b-spinner small type="grow"/>
                        กำลังโหลดข้อมูล...
                    </b-button>
                </div>
            </div>
            <div class="row" style="padding-top: 1rem">
                <div class="col-md-12 text-center">
                    <a class="btn btn-link" href="/password/reset">ลืมรหัสผ่าน ?</a>
                    |
                    <a class="btn btn-link" href="/register">สมัครสมาชิก</a>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import BButton from "bootstrap-vue/src/components/button/button";
    import BSpinner from "bootstrap-vue/src/components/spinner/spinner";
    import {mapGetters} from "vuex";

    export default {
        name: "Login",
        components: {BSpinner, BButton},
        data() {
            return {
                loading: false,
                form: {
                    email: '',
                    password: ''
                }
            }
        },
        created() {
            // this.form = {
            //     email: 'superadmin@mail.com',
            //     password: '123456'
            // }
            // this.login();
        },
        computed: {
            // mix the getters into computed with object spread operator
            ...mapGetters({
                user: "Auth/getUser"
            })
        },
        methods: {
            login() {
                this.loading = true;
                this.$store.dispatch("Auth/login", this.form)
                    .then(res => {
                        if (res.status === "success") {
                            this.$toasted.show('เข้าสู่ระบบสำเร็จ', {
                                type: 'success',
                                icon: 'check',
                                iconPack: 'fontawesome',
                                duration: 5000
                            });
                            this.$router.push({name: 'home'})
                        } else if (res.status === "Validate Fails.") {
                            let message = `Validate Fails.<br>${res.result.join("<br>")}`;
                            this.$toasted.show(message, {
                                type: 'error',
                                icon: 'exclamation-circle',
                                iconPack: 'fontawesome',
                                duration: 5000
                            });
                        } else {
                            let message = `อีเมล หรือ รหัสผ่านของคุณไม่ถูกต้อง`;
                            this.$toasted.show(message, {
                                type: 'error',
                                icon: 'exclamation-circle',
                                iconPack: 'fontawesome',
                                duration: 5000
                            });
                        }
                        this.loading = false;
                    })
                    .catch(err => {
                        console.log(err.message)
                        this.$toasted.show("เกิดข้อผิดพลาด โปรดลองใหม่อีกครั้ง", {
                            type: 'error',
                            theme: "toasted-primary",
                            position: "top-right",
                            duration: 5000
                        });
                        this.loading = false
                    });
            }
        }
    }
</script>

<style scoped>
    form {
        padding: 1.25rem;
        border: brown solid thin;
        background: azure;
        margin-top: 25vh;
    }
</style>